<div class="loading-container">
<div *ngIf="loading" class="loading-spinner-overlay">
  <div class="ndnqi-spinner"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>  
</div>

<div *ngIf="!loading">
<div class="container-fluid">
    <div class="row">
      <div class="col-sm-12">
        <nav>
            <div class="nav nav-tabs customTabber" id="nav-tab" role="tablist">
              <button class="nav-item nav-link active" 
                          id="nav-filestatus-tab" 
                          data-bs-toggle="tab" 
                          data-bs-target="#nav-filestatus" 
                          type="button"
                          role="tab"
                          aria-controls="nav-filestatus" 
                          aria-selected="true">
                    Requested Files
                  </button>
                  <button *ngIf="showTab" 
                          class="nav-item nav-link" 
                          id="nav-activity-tab" 
                          data-bs-toggle="tab" 
                          data-bs-target="#nav-activity" 
                          type="button"
                          role="tab"
                          aria-controls="nav-activity" 
                          aria-selected="false">
                    Activity Log
                  </button>    </div>
        
            <div class="BTNrefresh">
              <button (click)="onRefreshClicked()" type="submit" class="btn btn-default" title="generate export file"><i class="fas fa-sync-alt"></i>Refresh</button>
            </div>
          </nav>    
          <div class="tab-content" id="nav-tabContent">
            <div class="tab-pane fade show active" id="nav-filestatus" role="tabpanel" aria-labelledby="nav-filestatus-tab">
              <app-facility-export-file-status 
                [hospid]="hospid" 
                [facilityExportRequestedFiles]="facilityExportRequestedFiles">
              </app-facility-export-file-status>
            </div>
            <div class="tab-pane fade" id="nav-activity" role="tabpanel" aria-labelledby="nav-activity-tab">
              <app-facility-export-activity-log 
                (showTab)="checkActivityTabStatus($event)" 
                [hospid]="hospid" 
                [facilityExportActivity]="facilityExportActivityLog" 
                [isAdmin]="isAdmin"
                >
              </app-facility-export-activity-log>
            </div>
          </div>
      </div>
    </div>
</div>
</div>
</div>